import ajax from '../utils/request'

const transApi = {
  /********************************充值订单管理列表*********************************** */
  // 请求充值订单列表
  getOrderList(params) {
    return ajax({
      url: '/recharge/order/list',
      type: 'get',
      params: params
    })
  },
  getPayChannelList(params) {
    return ajax({
      url: '/recharge/rchgchan/list',
      type: 'get',
      params: params
    })
  },
  payChannelEdit(params){
    return ajax({
      url: '/recharge/rchgchan/edit',
      type: 'post',
      params: params
    })
  },
  // 编辑状态说明
  editStatusText(params) {
    return ajax({
      url: '/recharge/order/update',
      type: 'post',
      params: params
    })
  },
  // 把订单信息通知到第三方平台
  handAddScore(params) {
    return ajax({
      url: '/daichong/order/handScore',
      type: 'post',
      params: params
    })
  },
  /********************************提现订单管理列表*********************************** */
  // 请求提现列表
  getWithdrawList(params) {
    return ajax({
      url: '/withdraw/list',
      type: 'get',
      params: params
    })
  },
  // 提现审核
  WithdrawExamine(params) {
    return ajax({
      url: '/withdraw/check',
      type: 'post',
      params: params
    })
  },
  /********************************提现方式*********************************** */
  // 新增提现方式
  addWChannel(params) {
    return ajax({
      url: '/withdraw/channel/add',
      type: 'post',
      params: params
    })
  },
  // 获取提现方式配置列表
  getWChannelList(params) {
    return ajax({
      url: '/withdraw/channel/list',
      type: 'get',
      params: params
    })
  },
  // 修改提现方式配置
  updateWChannel(params) {
    return ajax({
      url: '/withdraw/channel/update',
      type: 'post',
      params: params
    })
  },
  // 修改提现税率
  updateTax(params) {
    return ajax({
      url: '/withdraw/channel/batch',
      type: 'post',
      params: params
    })
  },
  // 删除提现方式配置
  delWChannel(params) {
    return ajax({
      url: '/withdraw/channel/delete',
      type: 'delete',
      params: params
    })
  },
  /********************************提现银行配置*********************************** */
  // 提现银行配置列表配置
  cashBankList(params) {
    return ajax({
      url: '/bankType/list',
      type: 'get',
      params: params
    })
  },
  // 提现银行配置新增
  addCashBank(params) {
    return ajax({
      url: '/bankType/add',
      type: 'post',
      params: params
    })
  },
  // 提现银行配置编辑
  editCashBank(params) {
    return ajax({
      url: '/bankType/update',
      type: 'post',
      params: params
    })
  },
  // 提现银行配置删除
  delCashBank(params) {
    return ajax({
      url: '/bankType/del ',
      type: 'delete',
      params: params
    })
  },

  /******************************财务转账列表******************************/
  // 获取财务转账列表
  getTransferList(params) {
    return ajax({
      url: '/withdraw/finan/list',
      type: 'get',
      params: params
    })
  },
// 回执请求
receipt(params) {
  return ajax({
    url: '/withdraw/finan/receipt',
    type: 'post',
    params: params
  })
},


  /******************************退款列表******************************/
  // 获取退款列表
  getRefundList(params) {
    return ajax({
      url: '/withdraw/refund/list',
      type: 'get',
      params: params
    })
  },
// 请求
Refund(params) {
  return ajax({
    url: '/withdraw/refund/dealwith ',
    type: 'post',
    params: params
  })
},
}
export default transApi
